import { render } from "./FooterApp.vue?vue&type=template&id=70b9007b&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "@/assets/css/Footer.css?vue&type=style&index=0&id=70b9007b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b9007b"]])

export default __exports__